/** Tiny localStorage JSON helpers (fail-safe in private browsing). */

export function loadJSON<T>(key: string, fallback: T): T {
  try {
    const raw = window.localStorage.getItem(key);
    return raw ? (JSON.parse(raw) as T) : fallback;
  } catch {
    return fallback;
  }
}

export function saveJSON(key: string, value: unknown): void {
  try {
    window.localStorage.setItem(key, JSON.stringify(value));
  } catch {
    /* storage unavailable — ignore */
  }
}

export const storageKeys = {
  rulePack: (id: string) => `taa-arena-rules-${id}`,
  robot: (id: string) => `taa-arena-robot-${id}`,
  lastResult: (id: string) => `taa-arena-result-${id}`,
  bestScore: (id: string) => `taa-arena-best-${id}`,
  /** Selected arena/track id for competitions that offer more than one (e.g. line follower). */
  arena: (id: string) => `taa-arena-track-${id}`,
  /** Competitor's saved Arduino firmware for a competition (captured from the workbench). */
  firmware: (id: string) => `taa-arena-firmware-${id}`,
  /** Scope handed to the wiring/code workbench (allowed parts + rule limits). */
  scope: () => 'taa-arena-scope',
};

/** Key the sandbox's Monaco editor auto-saves the current code under. */
export const SANDBOX_CODE_KEY = 'arduinoCodeAutoSave';
